import { AxiosError } from 'axios'

import { AddressClient } from '@/api/modules/addresses/addresses.types'
import {
  AdditiveItem,
  ClientPack,
  Cost,
  DeliveryMethods,
  ErrorData,
  Gift,
  Item,
  PromocodeType,
  PropositionItem,
} from '@/api/modules/basket/types'
import { BasketPoint } from '@/types/api/api-v3/basket-points'
import { LoadState } from '@/types/main'

export type BasketState = LoadState<Basket, AxiosError<ErrorData>>

export interface Basket {
  totalPrice: number
  totalAmount: number
  amountToPay: number
  itemsCount: number
  items: Item[]
  additives: AdditiveItem[]
  maxNumberOfPersons: number
  persons: Persons
  promocode: Promocode
  delivery: {
    cost: Cost | null
    method: DeliveryMethods
    addresses: {
      [K in DeliveryMethods]: number | string
    }
  }
  gifts: Gift[]
  bonuses: Bonuses
  selectedPaymentMethod: string | null | undefined
  note: string
  change: number
  selectedGifts: SelectedGift[]
  proposition: Proposition
  clientPacks: ClientPack[]
  doNotCallMeBack: boolean
  isExtra: boolean
}

export interface SelectedGift {
  rule_id: number | null
  product_id: number | null
}

export interface Persons {
  errorMessage: string
  helpMessage: string
  maxNumber: number | null
  message: string
  number: number | null
}

export interface Promocode {
  discountAmount: number
  title: string
  value: string
  valid: boolean
  error: string
  type: PromocodeType | null
}

export interface Bonuses {
  toSpendAmount: number
  maxSpendAmount: number
  toAccrueAmount: number
  totalAmount: number
  errorMessage: string
  message: string
}

export interface Proposition {
  timeToLive: number
  popupText: string
  items: PropositionItem[]
}

export function isAddressClient(
  address: AddressClient | BasketPoint | undefined,
): address is AddressClient {
  if (!address) {
    return true
  }

  return (address as AddressClient).is_in_delivery_area !== undefined
}
